import { Box, IconButton, TableCell, TextField, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import { formatNum } from "../../utils/formatters";

const stop = (e) => e.stopPropagation();

const ValueCell = ({ value, sx }) => (
  <TableCell align="center" onClick={stop}>
    <Typography variant="body2" sx={sx}>
      {value}
    </Typography>
  </TableCell>
);

const AgentDiscountCell = ({ item, edit, isEditing, isSaved, onChange }) => (
  <TableCell align="center" sx={{ bgcolor: isEditing ? "#f0f7ff" : "transparent" }} onClick={stop}>
    {isEditing ? (
      <TextField
        size="small"
        type="number"
        value={edit.NEO_AGENTDISC ?? item.NEO_AGENTDISC ?? ""}
        onChange={(e) => onChange("NEO_AGENTDISC", e.target.value)}
        inputProps={{ style: { fontSize: "0.78rem", padding: "3px 6px", width: 60 } }}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1 } }}
      />
    ) : (
      <Typography variant="body2" sx={{ color: isSaved ? "#217346" : "#1f2937", fontWeight: isSaved ? 700 : 400 }}>
        {formatNum(edit.NEO_AGENTDISC ?? item.NEO_AGENTDISC)}
      </Typography>
    )}
  </TableCell>
);

const ItemActionsCell = ({ isEditing, onToggleEdit, onLastSales }) => (
  <TableCell align="center" onClick={stop}>
    <Box display="flex" alignItems="center" justifyContent="center">
      <Tooltip title={isEditing ? "בטל עריכה" : "ערוך מחיר / הנחה"}>
        <IconButton
          size="small"
          onClick={onToggleEdit}
          sx={{ color: isEditing ? "#dc2626" : "#6b7280", "&:hover": { color: isEditing ? "#b91c1c" : "#0054A5" } }}
        >
          {isEditing ? <CloseIcon fontSize="small" /> : <EditIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Tooltip title="מכירות אחרונות">
        <IconButton
          size="small"
          onClick={(e) => {
            stop(e);
            onLastSales();
          }}
          sx={{ color: "#6b7280", "&:hover": { color: "#0054A5" } }}
        >
          <HistoryIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  </TableCell>
);

// Price / discount / actions cells of one order line (ItemRow's extraCells).
const ItemEditCells = ({ item, edit, isEditing, isSaved, onChange, onToggleEdit, onLastSales }) => (
  <>
    <ValueCell value={formatNum(item.PRICE)} sx={{ color: "#1f2937" }} />
    <ValueCell value={formatNum(item.DISPRICE)} sx={{ color: "#217346", fontWeight: 600 }} />
    <AgentDiscountCell item={item} edit={edit} isEditing={isEditing} isSaved={isSaved} onChange={onChange} />
    <ValueCell value={`${formatNum(item.PERCENT)}%`} sx={{ color: "#0054A5", fontWeight: 600 }} />
    <ItemActionsCell isEditing={isEditing} onToggleEdit={onToggleEdit} onLastSales={onLastSales} />
  </>
);

export default ItemEditCells;
